class EmittentenService {
  constructor($rootScope, $http, $httpParamSerializer, $timeout) {
    'ngInject';
    this.$rootScope = $rootScope;
    this.$httpParamSerializer = $httpParamSerializer;
    this.$http = $http;
    this.$timeout = $timeout;
  }

  setData(data) {
    return this.getCurrentEventId().then((result) => {
      if (data.anmeldung_typ) {
        var anmeldung_typ = '&anmeldung_typ=' + data.anmeldung_typ;
      } else {
        var anmeldung_typ = '';
      }
      data.language = this.$rootScope.language;
      data.event_id = this.$rootScope.config.event_id;
      return this.$http({
        //url: this.$rootScope.config.url + 'anmeldung.php?lang=' + this.$rootScope.language,
        url: this.$rootScope.config.api2 + 'user/register',
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: this.$httpParamSerializer(data),
      }).then(
        (result) => {
          return result;
        },
        (response) => {
          return response.data;
        }
      );
    });
  }

  isJson(jsonString) {
    try {
      var o = JSON.parse(jsonString);

      if (o && typeof o === 'object') {
        return true;
      }
    } catch (e) {}

    return false;
  }

  convertToObject(jsonstring, standardValue) {
    var returnObject = {};
    if (this.isJson(jsonstring)) {
      returnObject = JSON.parse(jsonstring);
    } else {
      return jsonstring;
      /*
        returnObject = {
            de: standardValue || "",
            en: standardValue || ""
        }
        */
    }
    return returnObject;
  }

  getCountries(lang) {
    return this.$http
      .post(this.$rootScope.config.api2 + 'data/countries/get', { lang: lang })
      .then(
        (result) => {
          return result.data;
        },
        (response) => {
          console.error(response);
        }
      );
  }

  getSelectFields(group_id, lang) {
    return this.$http
      .post(this.$rootScope.config.api2 + 'data/selectFields/get', {
        field_group: group_id,
        lang: lang,
        search: {
          sort: { name: 1 },
        },
      })
      .then(
        (result) => {
          return result.data;
        },
        (response) => {
          console.error(response);
        }
      );
  }

  getCurrentEventId() {
    if (this.$rootScope.config.event_id)
      return this.$timeout(() => {
        return this.$rootScope.config.event_id;
      });
    return this.$http
      .post(this.$rootScope.config.api2 + 'events/get', {
        search: { getLatestPublishedEvent: true },
      })
      .then(
        (result) => {
          this.$rootScope.config.event_id = result.data[0].id;
          return result.data[0].id;
        },
        (response) => {
          console.error(response);
        }
      );
  }

  //id is optional. Default: 1
  getSegmentTags(lang, id) {
    let postData= {
      lang: lang,
      type: 1,
      search: {
        sort: { name: 1 },
      },
    }
    if(id)postData.type = id
    return this.$http
      .post(this.$rootScope.config.api2 + 'tags/getTags', postData)
      .then(
        (result) => {
          return result.data;
        },
        (response) => {
          console.error(response);
        }
      );
  }
  getInvestorTypes(lang) {
    return this.$http
      .post(this.$rootScope.config.api2 + 'tags/getTags', {
        lang: lang,
        type: 7,
        search: {
          sort: { name: 1 },
        },
      })
      .then(
        (result) => {
          return result.data;
        },
        (response) => {
          console.error(response);
        }
      );
  }
  getRegionalFocus(lang) {
    return this.$http
      .post(this.$rootScope.config.api2 + 'tags/getTags', {
        lang: lang,
        type: 3,
        search: {
          sort: { name: 1 },
        },
      })
      .then(
        (result) => {
          return result.data;
        },
        (response) => {
          console.error(response);
        }
      );
  }

  getInvestmentStages(lang) {
    return this.$http
      .post(this.$rootScope.config.api2 + 'tags/getTags', {
        lang: lang,
        type: 2,
      })
      .then(
        (result) => {
          return result.data;
        },
        (response) => {
          console.error(response);
        }
      );
  }

  getHeadquarters(lang) {
    return this.$http
      .post(this.$rootScope.config.api2 + 'tags/getTags', {
        lang: lang,
        type: 4,
      })
      .then(
        (result) => {
          return result.data;
        },
        (response) => {
          console.error(response);
        }
      );
  }

  getEventPackets(lang, type) {
    return this.getCurrentEventId().then(
      (result) => {
        return this.$http
          .post(this.$rootScope.config.api2 + 'events/packet/get', {
            lang: lang,
            type: type,
            event_id: this.$rootScope.config.event_id,
            withjoin: { tbl_events_packets_discounts: true },
          })
          .then(
            (result) => {
              return result.data;
            },
            (response) => {
              console.error(response);
            }
          );
      },
      (response) => {
        console.error(response);
      }
    );
  }

  backendLogin(email, password) {
    return this.$http
      .post(this.$rootScope.config.api2 + 'user/login', {
        email: email,
        password: password,
      })
      .then(
        (result) => {
          return result.data;
        },
        (response) => {
          console.error(response);
        }
      );
  }

  checkEmail(email) {
    return this.$http
      .post(this.$rootScope.config.api2 + 'user/checkEMail', {
        email: email
      })
      .then(
        (result) => {
          return result.data;
        },
        (response) => {
          console.error(response);
        }
      );
  }
}

export default EmittentenService;



// WEBPACK FOOTER //
// ./client/app/common/forms/emittenten/emittenten.service.js